import { ChangeEvent, FC, FocusEventHandler, memo } from 'react'
import { CompanyType } from '@leadgen/models/client'
import { RadioButton } from '../../../atoms/RadioButton'
import useStableCallback from '../../../../hooks/shared/useStableCallback'

const companyTypeMap: Record<CompanyType, { title: string }> = {
  builder: {
    title: 'Building',
  },
  glazier: {
    title: 'Glazing',
  },
  landscaper: {
    title: 'Landscaping',
  },
  renewables: {
    title: 'Renewables',
  },
  flooring: {
    title: 'Flooring',
  },
  kitchen: {
    title: 'Kitchens',
  },
  retail: {
    title: 'Retail',
  },
}

const CompanyTypeTile: FC<{
  companyType: CompanyType
  selected: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
}> = ({ companyType, selected, onChange: baseOnChange, onBlur }) => {
  const onChange = useStableCallback(() => {
    baseOnChange({
      target: { value: companyType },
    } as React.ChangeEvent<HTMLInputElement>)
  })
  return (
    <RadioButton
      onBlur={onBlur}
      onChange={onChange}
      value={companyType}
      checked={selected}
      label={companyTypeMap[companyType].title}
    />
  )
}

export default memo(CompanyTypeTile)
